/* eslint-disable */
import { BiShoppingBag, BiPencil } from "react-icons/bi";
import { BsCodeSlash, BsClipboardData } from "react-icons/bs";
import { AiOutlineMail, AiFillAudio } from "react-icons/ai";
import {
  FaInternetExplorer,
  FaChalkboardTeacher,
  FaCameraRetro,
  FaPinterest,
  FaVideo,
  FaTabletAlt,
  FaRegNewspaper,
} from "react-icons/fa";

export const servicesData = [
  {
    id: 3,
    title: "Web Design",
    icon: <BsCodeSlash />,
  },
  // {
  //     id: 4,
  //     title: 'Photography',
  //     icon: <FaCameraRetro />
  // },

  {
    id: 5,
    title: "Video Editing",
    icon: <FaVideo />,
  },

  // {
  //     id: 6,
  //     title: 'Blog Posting',
  //     icon: <FaRegNewspaper />
  // },
  {
    id: 7,
    title: "Teaching",
    icon: <FaChalkboardTeacher />,
  },
  {
    id: 1,
    title: "Marketing",
    icon: <BiShoppingBag />,
  },
  {
    id: 2,
    title: "Creator",
    icon: <BiPencil />,
  },
];
